import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
  TemplateRef
} from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { Observable } from 'rxjs';

import { DisplaySchema, SummitIdObject } from '@summit/models';
import { ApiError } from '@summit/ui';

import { Button } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { SFormErrorTotalComponent } from '../form-error-total';

@Component({
  selector: 's-form-page',
  templateUrl: './s-form-page.component.html',
  styleUrls: ['./s-form-page.component.scss'],
  standalone: true,
  imports: [SFormErrorTotalComponent, ReactiveFormsModule, Button, AsyncPipe, CardModule, NgTemplateOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SFormPageComponent<T extends SummitIdObject> implements OnInit {
  @Input() id = 'elementForm';
  @Input() schema: DisplaySchema<T> | false;
  @Input() apiError: ApiError;
  @Input() formGroup: FormGroup;
  @Input() title?: string;
  @Input() submitting$: Observable<boolean>;
  @Input() backLabel?: string;
  @Input() backLabel$?: Observable<string>;
  @Input() saveLabel?: string;
  @Input() saveLabel$?: Observable<string>;
  @Input() nextLabel?: string;
  @Input() nextLabel$?: Observable<string>;
  @Input() showBack: boolean;
  @Input() showSave: boolean;
  @Input() showNext: boolean;
  @Input() blockBack$: Observable<boolean>;
  @Input() blockSave$: Observable<boolean>;
  @Input() blockNext$: Observable<boolean>;
  @Input() disableFloating: boolean;
  @Output() save = new EventEmitter<unknown>();
  @Output() next = new EventEmitter<unknown>();
  @Output() back = new EventEmitter<unknown>();
  @ContentChild('title') titleTemplate: TemplateRef<unknown>;
  @ContentChild('subTitle') subTitleTemplate: TemplateRef<unknown>;
  @ContentChild('footer') footerTemplate: TemplateRef<unknown>;

  inDialog = false;
  childComponent = false;
  showBackNext = false;

  constructor(private elRef: ElementRef) {
    try {
      const dialogRef = inject(DynamicDialogRef);
      if (dialogRef) {
        this.inDialog = true;
        //console.log('In dialog');
      }
    } catch (e) {
      //console.log('Not in dialog');
    }
    //if delayed in rendering, then child component
    // console.log(
    //   `SFormPageComponent : ${this.elRef?.nativeElement?.parentElement?.tagName}`,
    //   this.elRef?.nativeElement?.parentElement
    // );
    if (
      !this.elRef?.nativeElement?.parentElement ||
      this.elRef?.nativeElement?.parentElement?.tagName === 'S-FORM-WIZARD'
    ) {
      this.childComponent = true;
    }
    //console.log('SFormPageComponent', this.inDialog, this.childComponent);
  }

  ngOnInit(): void {
    this.backLabel ??= '<< Back';
    this.saveLabel ??= 'Save';
    this.nextLabel ??= 'Next >>';
    this.title ??= this.schema ? this.schema?.refTitle : undefined;
    this.showSave ??= true;
  }

  onSave($event) {
    //console.log(`Save Event`, $event);
    this.save.emit($event);
  }

  nextEvent($event) {
    $event.preventDefault();
    $event.stopPropagation();
    this.next.emit($event);
  }
  priorEvent($event) {
    $event.preventDefault();
    $event.stopPropagation();
    this.back.emit($event);
  }
}
